module.exports = __webpack_public_path__ + "img/3.a7a0feb3.png";